export default __webpack_public_path__ + "38ba75970bf6bb9fa8dd2ea6d76f5eb2.png";